import styled from 'styled-components';
import { SSpacedRow } from 'styles/layout';

export const STitle = styled(SSpacedRow)`
    margin-bottom: 2rem;
`;
